"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Form = void 0;
var _react = _interopRequireDefault(require("react"));
var _definitions = require("@ppay/definitions");
var _reactResponsive = require("react-responsive");
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ui = require("../../../../../ui");
var _ticker = require("../../../../../ticker");
var _utils = require("../../../../../../utils");
var _QRCode = require("../QRCode");
var _form = require("../../../form");
var _hooks = require("../../../../../../hooks");
var _Confirmations, _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Confirmations = (_Confirmations = {}, _defineProperty(_Confirmations, _definitions.Blockchain.BINANCE_SMART_CHAIN, 12), _defineProperty(_Confirmations, _definitions.Blockchain.ETHEREUM, 12), _defineProperty(_Confirmations, _definitions.Blockchain.POLYGON, 12), _defineProperty(_Confirmations, _definitions.Blockchain.BITCOIN, 3), _defineProperty(_Confirmations, _definitions.Blockchain.TRON, 19), _Confirmations);
var BoldText = _styledComponents.default.b(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tertiary;
});
var Form = function Form() {
  var isXlScreen = (0, _reactResponsive.useMediaQuery)({
    minWidth: _utils.breakpoints.xl
  });
  var _useTranslation = (0, _reactI18next.useTranslation)(['libTransfers', 'libCommon']),
    t = _useTranslation.t;
  var _useReplenishContext = (0, _hooks.useReplenishContext)(),
    crypto = _useReplenishContext.crypto;
  return /*#__PURE__*/_react.default.createElement("form", null, /*#__PURE__*/_react.default.createElement(_ui.Row, null, /*#__PURE__*/_react.default.createElement(_ui.Col, {
    xs: 12,
    md: 6
  }, /*#__PURE__*/_react.default.createElement(_ui.FormGroup, null, /*#__PURE__*/_react.default.createElement(_ui.Label, null, t('chooseCurrencyToReceive'), ":"), /*#__PURE__*/_react.default.createElement(_ticker.TickerSelectInput, {
    value: crypto.ticker,
    tickers: crypto.tickers,
    balances: crypto.balances,
    onChange: function onChange(value) {
      return crypto.setTicker(value);
    }
  }))), /*#__PURE__*/_react.default.createElement(_ui.Col, {
    xs: 12,
    md: 6
  }, /*#__PURE__*/_react.default.createElement(_ui.FormGroup, null, /*#__PURE__*/_react.default.createElement(_ui.Label, null, t('network')), /*#__PURE__*/_react.default.createElement(_form.BlockchainSelectInput, {
    value: crypto.blockchain,
    options: crypto.blockchains,
    onChange: crypto.setBlockchain
  })))), crypto.loading ? /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex justify-content-center align-items-center pt-3 pb-4 pb-sm-5"
  }, /*#__PURE__*/_react.default.createElement(_ui.Spinner, {
    color: "primary",
    size: "lg"
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !isXlScreen && /*#__PURE__*/_react.default.createElement(_ui.FormGroup, null, /*#__PURE__*/_react.default.createElement(_QRCode.QRCode, null)), /*#__PURE__*/_react.default.createElement(_ui.FormGroup, null, /*#__PURE__*/_react.default.createElement(_ui.Label, null, t('libCommon:currentBalance')), /*#__PURE__*/_react.default.createElement(_ui.PrimaryAmountWithEquivalent, {
    amount: crypto.balance,
    ticker: crypto.ticker,
    convertedTicker: crypto.convertedTicker,
    convertedAmount: crypto.convertedBalance
  })), /*#__PURE__*/_react.default.createElement(_ui.FormGroup, null, /*#__PURE__*/_react.default.createElement(_ui.Label, null, t('replenishAddress')), /*#__PURE__*/_react.default.createElement(_ui.WithReveal, {
    disabled: crypto.revealDisabled,
    revealed: !!crypto.address,
    onReveal: crypto.onReveal
  }, /*#__PURE__*/_react.default.createElement(_ui.InputGroupAbsolute, null, /*#__PURE__*/_react.default.createElement(_ui.CopyInputGroupAddon, {
    value: crypto.address,
    addonType: "append"
  }), /*#__PURE__*/_react.default.createElement(_ui.CopyInput, {
    value: crypto.address
  }))))), /*#__PURE__*/_react.default.createElement(_ui.Alert, null, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "libTransfers:replenishAttention",
    values: {
      confirmations: Confirmations[crypto.blockchain]
    }
  }, /*#__PURE__*/_react.default.createElement(BoldText, null))));
};
exports.Form = Form;